<template>
  <div class="flex w-full" style="position: relative">
    <div v-if="!coverageIteration" class="w-full h-full flex items-center justify-center title">
      {{
        $t(
          isAloDbMissionGlobalCoverage(missionGlobal)
            ? 'Simulation.NoCoverageIterationSelected'
            : 'Simulation.NoFormationIterationSelected',
        )
      }}
    </div>
    <div v-else-if="gliderKeys.length" class="d-flex flex-col w-full h-full">
      <v-tabs v-model="selectedGliderIdx" align-with-title class="flex-grow-0">
        <v-tab v-for="(glider, idx) in gliderKeys" :key="glider" :title="glider">
          {{ glider }}
        </v-tab>
      </v-tabs>
      <!-- <div style="height: 250px;overflow: auto;" v-if="mission_plan">{{ mission_plan}}</div>       -->
      <admin-mission-plan
        readonly
        v-if="mission_plan"
        ref="editPlan"
        :uiid="missionPlanUiid"
        :enablePayload="true"
        :enableAdvencedNav="true"
        @goto="goTo"
        @fit="fit"
      >
        <template v-slot:action></template>
      </admin-mission-plan>
      <!-- <div class="w-full grow" v-if="mission_plan" style="position: relative;" >              
        <div class="h-full w-full  scrollable-container" >
          <table v-if="mission_plan" class="w-full">
          <thead>
            <tr>
              <td>Step</td>
              <td>Rval</td>
              <td>Tval</td>
              <td>Profile nav</td>
              <td>Profile sci</td>
              <td>Payload</td>
            </tr>
          </thead>
          <tbody> 
            <template  v-for="(step,idx) in mission_plan.steps">
              <tr :class="{'bg-grey':idx%2==0}">
                <td>{{ step.wpt_id }}</td>
                <td>{{ step.rVal}}</td>
                <td>{{ step.tVal }}</td>
                <td>{{ step.prfNav_id }}</td>
                <td>{{ step.prfSci_id }}</td>
                <td>{{step.payload_enable}}</td>
              </tr>
              <tr :class="{'bg-grey':idx%2==0}">
                <td colspan="6">
                  Profile nav : {{ step.prfNav_id }}
                </td>            
              </tr>
              <tr :class="{'bg-grey':idx%2==0}">
                <td colspan="6">
                  Profile sci : {{ step.prfSci_id }}
                </td>            
              </tr>
            </template>
          </tbody>
        </table>
        </div>        
    </div> -->
    </div>
    <div v-else class="w-full h-full flex flex-col mx-4 items-center justify-center title gap-2">
      <span>{{ $t(stepTradKey) }}</span>
      <span>{{ $t(stateTradKey) }}</span>
      <v-progress-linear indeterminate color="primary"></v-progress-linear>
    </div>
  </div>
</template>
<script lang="ts">
import apiAdminMissionVirtual from '@/api/admin/missionVirtual'
import { MissionPlanUiState, buildMissionPlanStateId } from '@/models/ui/MissionPlanUiState'
import AdminMissionPlan from '@/components/admin/missionPlanTemplate/AdminMissionPlan.vue'
import Vue from 'vue'
import Component from 'vue-class-component'
import deepEqual from 'deep-equal'
import { Watch } from 'vue-property-decorator'
import { cloneDeep } from 'lodash'
import { buildSimulationUIStateId } from '@/models/ui/SimulationUiState'
import { MapUiState } from '@/models/ui/MapUiState'
import { SimulationStatus } from '@/enum/SimulationStatus'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import { Coordinate } from 'ol/coordinate'
import { Extent } from 'ol/extent'
import { buildCoverageStateId } from '@/models/ui/CoverageUiState'
import { getCoverageState, getCoverageStateTradKey } from '@/enum/CoverageState'
import { getCoverageStep, getCoverageStepTradKey } from '@/enum/CoverageStep'
import { buildCoverageIterationUiStateId } from '@/models/ui/CoverageIterationUiState'
import { AloDbMissionGlobal, isAloDbMissionGlobalCoverage } from '@/models/alodb/AloDbMissionGlobal'

@Component({
  name: 'CoverageDetailMissionPlan',
  components: { AdminMissionPlan },
})
export default class CoverageDetailMissionPlan extends Vue {
  get selectedGliderIdx() {
    return this.coverageIterationState?.misPlanSelectedGliderIdx ?? -1
  }
  set selectedGliderIdx(value: number) {
    this.coverageIterationState!.misPlanSelectedGliderIdx = value
  }

  get missionGlobal() {
    return this.$store.myGetters.modifiedAdmMissionGlobal
  }

  get coverage_uiid() {
    return buildCoverageStateId(this.missionGlobal.MIG_ID!, 'detail')
  }

  get coverageiteration_uiid() {
    return this.coverageState.selectedCoverageId
      ? buildCoverageIterationUiStateId(this.coverageState.selectedCoverageId!, 'detail')
      : null
  }

  get coverageState() {
    return this.$store.myGetters.coverageStateByUiid(this.coverage_uiid)
  }

  get coverageIteration() {
    return this.coverageState.selectedCoverageId
      ? this.$store.myGetters.coverageIterationsById[this.coverageState.selectedCoverageId]
      : null
  }

  get coverageIterationState() {
    return this.coverageiteration_uiid
      ? this.$store.myGetters.coverageIterationStateByUiid(this.coverageiteration_uiid)
      : null
  }

  get gliderKeys() {
    return Object.keys(this.coverageIteration?.resultMipJson || {}).filter(n => n.startsWith('GLIDER'))
  }

  get mission_plan() {
    return this.gliderKeys.length
      ? this.coverageIteration?.resultMipJson?.[this.gliderKeys[this.selectedGliderIdx]]?.mission_plan || null
      : null
  }

  get stateTradKey() {
    return getCoverageStateTradKey(getCoverageState(this.coverageIteration?.COV_PROCESSING_STATE))
  }

  get stepTradKey() {
    return getCoverageStepTradKey(getCoverageStep(this.coverageIteration?.COV_PROCESSING_STEP))
  }

  missionRunning = -1
  saving = false

  created() {
    this.$store.myActions.COVERAGEITERATION_ENSURE_LIST()
    this.$store.myActions.MISSIONGLOBAL_ENSURE_LIST()
    this.$store.myActions.UI_ENSURE_MISSIONPLAN_STATE({ id: this.original.MIG_ID || -1, typeUiid: 'simulation' })
    this.$store.myActions.MISSIONPLANTEMPLATE_ENSURE_LIST()
    if (this.mission_plan) this.plan = cloneDeep(this.mission_plan)
  }

  get uistatebyuiid() {
    return this.$store.myGetters.uistatebyuiid
  }

  get mapState() {
    //retourne un MapUiState
    return this.uistatebyuiid(this.map_uiid) as MapUiState
  }

  get bestFitMisId() {
    return this.mapState?.bestFitMisId
  }

  get modified() {
    return this.$store.myGetters.modifiedAdmMissionGlobal
  }

  get missionVirtualsById() {
    return this.$store.myGetters.missionVirtualsById
  }

  get selectedMission() {
    return this.missionVirtualsById[this.bestFitMisId]
  }

  get isRunning() {
    //TODO ameliorer avec enum
    return (
      this.selectedMission &&
      (this.selectedMission.result?.simulation_state == 'running' ||
        ((this.selectedMission.result?.simulation_state?.length ?? 0) == 0 &&
          (this.selectedMission?.VIM_STATUS ?? 0) > 0 &&
          this.selectedMission.VIM_STATUS != 10))
    )
  }

  get isRunnable() {
    //si toute les simulations ont un status différent de running
    return !this.isRunning
  }

  get original() {
    return this.$store.myGetters.originalAdmMissionGlobal
  }

  get missionPlanUiid() {
    return buildMissionPlanStateId(this.modified.MIG_ID || -1, 'simulation')
  }

  get missionPlanUiState() {
    return this.$store.myGetters.missionPlanUiStateByUiid(this.missionPlanUiid)
  }

  get plan() {
    return this.missionPlanUiState.missionPlan
  }
  set plan(value) {
    this.$store.myActions.UI_MISSIONPLAN_SET_MISSIONPLAN({
      uiid: this.missionPlanUiid,
      plan: value,
    })
  }

  get isOperator() {
    return this.$store.myGetters.isOperator
  }

  get isSysAdmin() {
    return this.$store.myGetters.isSysAdmin
  }

  get selectedFilterEnsIds() {
    //@ts-ignore
    return this.$store.myGetters.filterMission?.ensIds?.at(0) ?? undefined
  }

  templateId = -1

  @Watch('mission_plan')
  onMipModified() {
    if (this.mission_plan) this.plan = cloneDeep(this.mission_plan)
    //@ts-ignore
    else this.plan = null
  }

  get map_uiid() {
    return buildSimulationUIStateId(this.original.MIG_ID!, 'map')
  }

  goTo(coordinate: Coordinate) {
    //console.log("coordinate",coordinate)
    this.$store.myActions.UI_REFRESH_BEST_FIT_MAP(this.map_uiid)
  }

  fit(extent: Extent) {
    //console.log("extent",extent)
    this.$store.myActions.UI_REFRESH_BEST_FIT_MAP(this.map_uiid)
  }

  isAloDbMissionGlobalCoverage(missionGlobal: AloDbMissionGlobal): boolean {
    return isAloDbMissionGlobalCoverage(missionGlobal)
  }
}
</script>
<style lang="css">
.bg-grey {
  background-color: red;
}
</style>
